import React from 'react'
import Icon from 'atoms/Icon';
import IconPng from 'atoms/IconPng'
import { ButtonReg } from 'atoms/Buttons'

const ic_collab = require('App/assets/images/ic_collab.png')
const ic_eye = require('App/assets/images/ic_eye.png')

export const navCollabFormatter = (cell, row, rowIndex, formatExtraData) => {
  const { nav, path, fnSwitch, report } = formatExtraData
  return (
    <div>
      <ButtonReg
        width={'28px'}
        height={'28px'}
        onClick={() => nav(`${path}/${row.id}`)}
        btnTxt={
          <IconPng
            srcIcon={ic_collab}
            mx={'0'}
            size={'auto'}
            h={'16'}
            showPointer={true}
          />
        }
      />
      <ButtonReg
        width={'28px'}
        height={'28px'}
        className={'ml-2'}
        onClick={() => fnSwitch(row, 'View')}
        btnTxt={
          <IconPng
            srcIcon={ic_eye}
            mx={'0'}
            size={'auto'}
            mb={'3px'}
            h={'10'}
            showPointer={true}
          />
        }
      />
      {report && (
        <ButtonReg
          width={'28px'}
          height={'28px'}
          className={'ml-2'}
          onClick={() => nav(`${path}/${row.id}/${report}`)}
          btnTxt={
            <Icon
              ml="auto"
              name="table"
              color="#FFF"
              showPointer
            />
          }
        />
      )}
    </div>
  )
}
